import React, { useEffect, useState } from 'react';
import UploadCsv from '../components/upload-csv-input';
import GeoMapperMenuBar from '../components/geo-mapper-menu-bar';
import GeoMapperTable from '../components/geo-mapper-table';
import { useGetGeoMapperItemQuery, useGetGeoMapperItemsQuery } from '../endpoints/geo-mapper.endpoints';
import { GeoMapperItem } from '../types/geo-mapper.types';

export type DateFilterType = 'last_month' | 'this_month' | 'last_week' | 'last_quarter' | 'last_3_days' | 'yesterday' | 'year_to_date' | 'custom';

export type ActiveView = 'upload' | 'manage' | 'view';

const GeoMapperTab: React.FC = () => {
  const [activeView, setActiveView] = useState<ActiveView>('manage');
  const [selectedGeoMapperItem, setSelectedGeoMapperItem] = useState<GeoMapperItem | null>(null);
  const [filteredGeoMapperItems, setFilteredGeoMapperItems] = useState<GeoMapperItem[]>([]);
  const { data: geoMapperItems, isLoading, isError, refetch: refetchGeoMapperItems } = useGetGeoMapperItemsQuery();
  const { data: geoMapperItem, isLoading: isLoadingGeoMapperItem, isError: isErrorGeoMapperItem, refetch: refetchGeoMapperItem } = useGetGeoMapperItemQuery(
    {id: selectedGeoMapperItem?.id || ''});

  useEffect(() => {
    setFilteredGeoMapperItems(geoMapperItems || []);
  }, [geoMapperItems]);

  const handleSearchChange = (searchText: string) => {
    if (searchText.length > 0) {
      setFilteredGeoMapperItems(filteredGeoMapperItems?.filter((item) => item.display_name.toLowerCase().includes(searchText.toLowerCase()) || item.original_filename.toLowerCase().includes(searchText.toLowerCase())));
    } else {
      setFilteredGeoMapperItems(geoMapperItems || []);
    }
  };

  return (
    <div className="h-full flex flex-col space-y-4 p-6 pt-0">
      <div className="flex-1 space-y-6">
        <GeoMapperMenuBar
          activeView={activeView}
          onViewChange={setActiveView}
          className='bg-gray-201 text-black rounded-full'
          searchText={''}
          onSearchChange={(searchText) => {
            console.log('searchText', searchText);
            handleSearchChange(searchText);
          }}
          isFiltered={filteredGeoMapperItems.length > 0}
          resultCount={filteredGeoMapperItems.length}
          totalCount={geoMapperItems?.length || 0}
        />

        {activeView === 'manage' && (
          <div className='flex flex-col gap-4'>
            <UploadCsv onSuccess={refetchGeoMapperItems} />
            <GeoMapperTable
              items={filteredGeoMapperItems || []}
              onItemClick={(item) => setSelectedGeoMapperItem(item)}
            />
          </div>
        )}
        {/*
        {activeView === 'view' && (
          <div className='flex flex-col gap-4'>
            <div className='shadow-md rounded-lg overflow-hidden'>
              <LeafletVanillaMap
                geoData={geoMapperItem as unknown as GeoMapperData}
                dotSize={6}
                showLabels
                showLegend
                grayscaleTiles={false}
                style={{ height: 480 }}
              />
            </div>
            <div className='shadow-md rounded-lg overflow-hidden'>
              <GeoMapperTable
                onItemClick={(item) => setSelectedGeoMapperItem(item)}
                items={geoMapperItems || []}
              />
            </div>

          </div>
        )} */}

      </div>
    </div>
  );
};

export default GeoMapperTab;
